import en from './en';
import vi from './vi';
import korea from './korea';

export default {
  en,
  vi,
  korea,
};
